export enum GcpRequestFileType {
  Measurement,
  Photo,
}
